export enum PairingState {
    INITIAL = 'Initial',
    ASSIGNING = 'Assigning',
    ASSIGNED = 'Assigned',
    RECORDED = 'Recorded'
}